export default __webpack_public_path__ + "static/media/samsungGalaxyA70.f8524bb8.png";